import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CopyrightIcon from "@material-ui/icons/Copyright";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    padding: "15px 0",
    background: "#1c4c99",
    justifyContent: "center",
  },
  text: {
    color: "#ffb700",
  },
  icon: {
    color: "#ffb700",
    fontSize: "1.3rem",
    padding: "0 .3rem",
  },
}));

const Footer = (props) => {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Typography className={classes.text}>{"Singarajan G"}</Typography>
      <CopyrightIcon className={classes.icon} />
      <Typography className={classes.text}>
        {new Date().getFullYear()}
      </Typography>
    </footer>
  );
};

export default Footer;
